import { render, staticRenderFns } from "./PersonDrawer.vue?vue&type=template&id=45b85500&scoped=true&"
import script from "./PersonDrawer.vue?vue&type=script&lang=js&"
export * from "./PersonDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b85500",
  null
  
)

export default component.exports